/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmailOtpVerifyRequest = {
  properties: {
    type: {
      type: 'Enum',
      isRequired: true,
    },
    code: {
      type: 'string',
      isRequired: true,
    },
    email: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
